export const endPoints = {
    PUSH_NOTIFICATIONS_CONFIG: '/v1/push-notification/config',
    DEVICE_TOKEN_UPDATE: '/v1/device-token/updateToken',
    PUSH_NOTIFICATIONS_CONFIG_CLEAN: 'v1/push-notification/config/clean'
};
